// The sentry canary
import "shared/util/Canary.js";

// Legacy JS (Must go first, provides globals)
import "legacy/prototypeshim";
import "legacy/adblock";
import "legacy/keynames";
import "legacy/pagestate";
import "legacy/storage";
import "shared/util/ClientStats";
import "legacy/helpers";
import "legacy/okform";
import "legacy/oktooltip";
import "legacy/browser_detect";
import "legacy/AjaxSookies";
import "legacy/DateTime";
import "legacy/Timezone";
import "legacy/Utilities";
import "legacy/masthead";
import "legacy/modal";
import "legacy/oklike";
import "legacy/alistpremium";
import "legacy/okfb";
import "legacy/okinstagram";
import "legacy/log";
import "legacy/keybindings";
import "legacy/native_forms";
import "legacy/headerbar";
import "legacy/rolling_number";
import "legacy/okpopover";
import "legacy/localization";
import "legacy/timing";
import "legacy/port";
import "legacy/products";
import "legacy/boosts";
import "features/boosts";
import "legacy/displayads";
import "shared/util/EventUiManager";
import "shared/util/InstantEvents";
import "legacy/milestones";
import "legacy/okcountdown";
import "legacy/flip_counter";
import "legacy/text_countdown";
import "legacy/incognito";
import "legacy/photoutil";
import "legacy/okphotos";
import "legacy/adresizer";
import "legacy/profile_quickview";
import "legacy/limelight";

// Global apps
import "features/navbar";
import "features/global_messaging/setup";
import "features/sentry";
import "okmodal/app";
import "okpay/";

// Shared utils and components
import "shared/components/BlankState";
import "shared/components/DisplayAd";
import "shared/components/Modal";
import "shared/components/Str";
import "shared/components/Strf";

import "shared/util/ProfileActions";
import "shared/util/ScamWarning";
import "shared/util/voucherCheck";

import "shared/modules/deferredjs";
import "shared/modules/AsyncEmoji";

import OkC from "shared/util/OkcApi";
import OkLoader from "shared/util/OkLoader";
import FeedbackBanner from "shared/util/FeedbackBanner";
import Analytics from "analytics/util/Analytics";

window.OkC = OkC;
window.OkAnalytics = Analytics;
window.OkLoader = OkLoader;
window.FeedbackBanner = FeedbackBanner;

import "apps/common_css/index.scss";



// WEBPACK FOOTER //
// ./src/bundles/common/index.js